"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireDefault(require("react")),
    _reactDropzone = _interopRequireDefault(require("react-dropzone"));

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    "default": a
  };
}

var _default = function _default(a) {
  var b = a.onDrop,
      c = a.accept,
      d = a.children;
  return _react["default"].createElement(_reactDropzone["default"], {
    onDrop: b,
    accept: c
  }, function (a) {
    var b = a.getRootProps,
        c = a.getInputProps;
    return _react["default"].createElement("section", null, _react["default"].createElement("div", b(), _react["default"].createElement("input", c()), d));
  });
};

exports["default"] = _default;